<template>
  <v-container grid-list-lg class="pa-0" fluid>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editCustomer="selectedCustomer">
    </Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :title="`${count} Parents`" :access="checkRightStatus(5)" @add="add" @refresh="refresh" />
      <!-- <v-btn color="success" @click="runTest">run test</v-btn> -->
      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" label="Search" outlined prepend-inner-icon="search" rounded dense single-line
            hide-details clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink>
          <v-checkbox label="Show Balance Only" v-model="ShowBalanceOnly"></v-checkbox>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-data-table :server-items-length="count" :footer-props="{ 'items-per-page-options': [10, 25, 35, 50]}"
          class="pageHeight" :headers="headers" :items="customers" :search="search"
          :loading="loading" :options.sync="options" @current-items="updateTotal">
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-decoration-underline blue--text" @click="viewProfileNewTab(item)">{{ item.localId }}</td>
              <td class="text-left" @click="viewProfile(item)" >
                <span v-html="$highlight(item.name, search)">{{ item.name }} </span>

              </td>
              <td @click="viewProfile(item)">

                <v-tooltip bottom v-if="item.alert">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="red" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Note Alert: {{ item.note }}</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.stripeId">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="blue" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Paying With Stripe</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.MerchantCustomers.length">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Set for online payment</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.mohidId">
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="brown darken-1" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Paying With Mohid</span>
                </v-tooltip>


                <v-tooltip bottom v-if="item.payingCash">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="green" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Paying Cash</span>
                </v-tooltip>
              </td>

              <td class="text-left" @click="viewProfile(item)">
                <div v-html="$highlight(item.fatherPhoneNumber, search)">{{
                  item.fatherPhoneNumber }}</div>
                <div v-if="item.motherPhoneNumber"  v-html="$highlight(item.motherPhoneNumber, search)"
                  >
                  {{
                  item.motherPhoneNumber }}</div>
              </td>

              <!-- <td class="text-left" @click="viewProfile(item)" v-html="$options.filters.highlight(item.address, search.toLowerCase())
                ">
                {{ item.address }}
              </td>
              <td class="text-left" @click="viewProfile(item)" v-html="$options.filters.highlight(item.city, search.toLowerCase())
                ">
                {{ item.city }}
              </td> -->
              <td class="text-center" @click="viewProfile(item)" >
                {{ item.studentCount }}
              </td>
              <td class="text-right" @click="viewProfile(item)">
                <span>{{
                  item.balance | currency
                  }}</span>
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item @click="viewProfile(item)">
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item v-if="checkRightStatus(7)" @click="editCustomer(item)">
                      <v-list-item-title>{{
                        $t("buttons.edit")
                        }}</v-list-item-title>
                    </v-list-item>
                    <DeleteCustomer v-if="checkRightStatus(8)" :Customer="item" @submit="getList()" />
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:body.append="{ headers }">
            <!-- <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td :colspan="headers.length - 2" class="text-right font-weight-bold">
                List Total
              </td>

              <td class="text-right font-weight-bold">
                {{ total | currency }}
              </td>
              <td></td>
            </tr> -->
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td :colspan="headers.length - 2" class="text-right font-weight-bold">
                Result Total
              </td>

              <td class="text-right font-weight-bold">
                {{ fullTotal | currency }}
              </td>
              <td></td>
            </tr>
          </template>
          <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert> -->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import customerService from "../service.js";
import DeleteCustomer from "../components/DeleteCustomer";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  data() {
    return {
      ShowBalanceOnly: false,
      createDialog: false,
      editDialog: false,
      selectedCustomer: null,
      total: 0,
      fullTotal: 0,
      headers: [
        {
          text: "ID",
          value: "localId",
          sortable: true,
          align: "center",
        },
        {
          text: "Name",
          value: "name",
          sortable: true,
          align: "left",
        },
        {
          text: "",
          width: '55px',
          sortable: false,
        },
        {
          text: "Phone Number",
          value: "fatherPhoneNumber",
          align: "left",
          sortable: false,
        },

        // {
        //   text: "Address",
        //   value: "address",
        //   align: "left",
        //   sortable: true,
        // },
        // {
        //   text: "City",
        //   value: "city",
        //   align: "left",
        //   sortable: true,
        // },
        {
          text: "Student Count",
          value: "studentCount",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("labels.balance"),
          value: "balance",
          align: "left",
          sortable: true,
        },
        {
          text: "",
          value: "motherPhoneNumber",
          sortable: false,
        },
      ],
      pageCount: 0,
      search: "",
      refundDialog: false,
      selectedTask: null,
      customers: [],
      loading: true,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [false]
      },
    };
  },
  async created() {
    if (this.$route.query && this.$route.query.ShowBalanceOnly) {
      this.ShowBalanceOnly = this.$route.query.ShowBalanceOnly
    }
    this.getList();
    this.getOutstandingBalance();
    this.$events.listen("customerListEvent", () => {
      this.getList()
      this.getOutstandingBalance()
    });

    // this.reset();
  },
  beforeDestroy() {
    this.$events.remove("customerListEvent");
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    ShowBalanceOnly() {
      this.getList()
    },
    search: {
      handler() {
        this.getList();
      }
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  components: {
    Create,
    Edit,
    DeleteCustomer,
  },
  filters: {
    // highlight(words, query) {
    //   if (query) {
    //     var check = new RegExp(query.toLowerCase(), "ig");
    //     if (words) {
    //       return words.toString().replace(check, function (matchedText) {
    //         return '<span class="highlight">' + matchedText + "</span>";
    //       });
    //     } else {
    //       return words;
    //     }
    //   } else {
    //     return words;
    //   }
    // },
  },
  methods: {
    ...mapActions('customer', ['setCustomerList']),
    runTest() {
      console.log('running')
      customerService.fixSub().then((response) => {
        console.log('response', response)
      })
    },
    updateTotal(val) {
      this.total = 0;
      val.map((row) => {
        this.total += row.balance;
      });
    },
    viewProfile(val) {
      this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    viewProfileNewTab(val) {
      let routeData = this.$router.resolve({
        path: `/parents/${val.id}/profile`,
      });
      window.open(routeData.href, "_blank");
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    refresh() {
      this.getList();
    },
    getOutstandingBalance(){
      customerService.getOutstandingBalance().then((response) => {
        this.fullTotal = response.data;

        this.isLoading = false;
      });
    },
    getList() {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let offset = 0
      if (itemsPerPage > 0 && page) {
        offset = itemsPerPage * page - itemsPerPage;
      }
      let where = {
        limit: itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0]
      }
      if (this.ShowBalanceOnly) {
        where.hideZero = true
      }
      if (this.search && this.search.length >= 3) {
        where.search = this.search
      } else {
        where.offset = offset
      }
      return customerService
        .getAll(where)
        .then((response) => {
          console.log("response", response);
          this.customers = response.data;
          this.count = response.count;
          this.setCustomerList(response.data)
          this.loading = false;
          this.itemsPerPage = this.customers.length
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },
    editCustomer(customer) {
      this.selectedCustomer = customer;
      this.editDialog = true;
    },
    deleteCustomer(customer) {
      if (!this.checkRightStatus(39)) {
        this.$swal(
          "Delete Customer",
          "You are not allow to delete customer with balance.",
          "warning"
        );
        return false;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          customerService
            .delete(customer.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Customer has been deleted.", "success");
                this.getList();
              }
            })
            .catch((error) => {
              throw error;
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
